
















































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "../../models/Application";
import { Table } from "../../viewmodels/Table";
import { Order, OrderDetail, OrderStatus } from "../../viewmodels/Order";
import { LayoutViewModel } from "../../viewmodels/LayoutViewModel";

@Component({})
export default class extends Vue {
  public collection = app.tableCollection;
  public currentOrderCollection = app.currentOrderCollection;

  public search: string = "";
  public model: Table = new Table({}, this.collection);
  public orderModel: Order = new Order({}, this.currentOrderCollection);

  public layoutViewModel: LayoutViewModel = new LayoutViewModel(
    this.collection
  );

  public dialog = false;

  public rowsPerPageItems = [-1];
  public pagination = {
    rowsPerPage: -1
  };

  public headers = [
    { text: "Id", value: "id" },
    { text: "Customer", value: "customer_name" },
    { text: "Table", value: "table_name" },
    { text: "Status", value: "status" },
    { text: "Total", value: "total" },
    { text: "Actions", value: "" }
  ];

  public get backgroundStyle() {
    return {
      "border": "2px solid #ddd",
      "height": `${this.layoutViewModel.height}px`,
      "background-image": `url(${this.layoutViewModel.sourceUrl})`,
      "background-size": "cover"
    };
  }

  public async mounted() {
    this.search = this.collection.search;
    this.collection.refreshData();
    window.addEventListener("resize", this.onWindowResize);
    this.onWindowResize();

    try {
      const layoutModel = await app.layoutService.getLayoutImage();

      if (layoutModel) {
        this.layoutViewModel.sourceWidth = layoutModel.width;
        this.layoutViewModel.sourceHeight = layoutModel.height;
        this.layoutViewModel.sourceUrl = layoutModel.url;
      }
    } catch (e) {
      console.log(e);
    }
  }

  public beforeDestroy() {
    window.removeEventListener("resize", this.onWindowResize);
  }

  private onWindowResize() {
    const layout = this.$refs.layout as HTMLElement;
    if (layout) {
      const width = layout.clientWidth;
      const height = layout.clientHeight;
      this.layoutViewModel.width = width;
      //this.layoutViewModel.height = height;
    }
  }

  @Watch("search")
  public onSearchChange() {
    this.collection.doSearch(this.search);
  }

  public close() {
    this.dialog = false;
    this.currentOrderCollection.refreshData();
  }

  public view(item: Order) {
    this.orderModel = item;
    this.dialog = true;
  }

  public getStyle(model: any) {
    const selectedOrder = this.currentOrderCollection.find({
      table_id: model.id
    });

    let color = "var(--splitted-color)";
    if (selectedOrder && selectedOrder.status) {
      console.log(selectedOrder.status);
      switch (selectedOrder.status) {
        case OrderStatus.Ordered:
          color = "var(--ordered-color)";
          break;
        case OrderStatus.ReadyForDelivery:
          color = "var(--ready-for-delivery-color)";
          break;
        case OrderStatus.Delivered:
          color = "var(--delivered-color)";
          break;
        case OrderStatus.Paid:
          color = "var(--paid-color)";
          break;
        case OrderStatus.Splitted:
          color = "var(--splitted-color)";
          break;
      }
    }
    return (
      "fill:" + color + ";stroke-width:3;stroke:" + color + ";cursor:pointer;"
    );
  }

  public selectModel(model: any, event: any) {
    const selectedOrder = this.currentOrderCollection.find({
      table_id: model.id
    });
    if (selectedOrder) {
      this.view(selectedOrder);
    } else {
      this.$store.dispatch("showSnackbar", {
        message: "There are no orders for this table!"
      });
    }
  }
}
